
import { debounce } from "~/utils/underscore-utils";
import SvgIconFindStore from "~/components/svg/IconFindStore";

export default {
  components: { SvgIconFindStore },

  props: {
    initSearchTerm: { type: String, default: "" },
    svgIconName: { type: String, default: "" },
  },

  data() {
    return {
      searchTerm: this.initSearchTerm,
      locations: [],
      loading: false,
      suburb: "",
      state: "",
      postcode: "",
      showList: true,
      errors: [],
      debouncedSearch: () => {},
      cancelToken: null,
    };
  },

  watch: {
    initSearchTerm(value) {
      this.searchTerm = value;
    },
    locations() {
      this.showList = true;
    },
  },

  created() {
    this.debouncedSearch = debounce(this.search, 1000);
  },

  methods: {
    handleSearch(address) {
      this.searchTerm = address;
      this.debouncedSearch();
    },
    validate() {
      const searchTerm = this.searchTerm.trim();
      this.errors = [];
      if (searchTerm == "") {
        return;
      }

      if (searchTerm.length < 3) {
        this.errors.push("Please enter minimum 3 characters.");
      }
    },
    async search() {
      this.$emit("search");
      this.locations = [];
      this.validate();
      if (this.errors.length != 0 || !this.searchTerm.trim()) {
        return;
      }

      this.loading = true;
      try {
        this.locations = await this.autoSuggestionApi(this.searchTerm);
        this.locations.length === 0 &&
          this.errors.push("Postcode/Suburb entered is invalid.");
      } catch (err) {
        if (this.$axios.isCancel(err)) {
          console.log("Request canceled", err.message);
        } else {
          this.$bugsnag.notify(err);
        }
      }
      this.loading = false;
    },
    handleItemClick({ locality: suburb = "", state = "", postcode = "" } = {}) {
      this.showList = false;
      this.suburb = suburb;
      this.state = state;
      this.postcode = postcode;
      this.searchTerm = `${suburb} ${state} ${postcode}`;
      this.validate();
      if (this.errors.length != 0) {
        return;
      }

      this.$emit("search-item", { suburb, state, postcode });
    },
    handleSearchItem() {
      if (!this.suburb && !this.state && !this.postcode) {
        return;
      }

      this.$emit("search-item", {
        suburb: this.suburb,
        state: this.state,
        postcode: this.postcode,
      });
    },
    autoSuggestionApi(suburbPostcode) {
      if (this.cancelToken) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }

      this.cancelToken = this.$axios.CancelToken.source();

      // const refinedSuburbPostcode = suburbPostcode.replace(
      //   /[^A-Za-z0-9 ]/g,
      //   ""
      // );
      const encodedValue = encodeURIComponent(suburbPostcode);
      const url = `${this.$config.snoozePortal}/api/postsubs/${encodedValue}`;

      return this.$axios
        .get(url, {
          headers: { apiKey: this.$config.snoozeSystemApiKey },
          cancelToken: this.cancelToken.token,
        })
        .then(response => response.data.data);
    },
  },
};
